import React, { useState, useEffect } from "react";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import { CiCirclePlus } from "react-icons/ci";
import { Row, Col, Container, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

const ConfirmPackageManually = () => {
  const [blockNumber, setBlockNumber] = useState();
  const [loading, setLoading] = useState(false);

  const handleUpdate = async () => {
    try {
      setLoading(true);
      const body = { blockNumber: blockNumber };
      console.log("body", body);
      const { data, error } = await apiCall("POST", `/confirm-order-with-dap`, body);
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Package confirmed successfully!");
        setBlockNumber("");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <div className="bonanza-settings">
          <div className="input-row1">
            <h2>Confirm Package Manually</h2>
            <div className="input-group2">
              <label>Confirm Package Manually:</label>
              <input
                type="number"
                name="confirmPackageManually"
                placeholder="Enter Block Number"
                value={blockNumber}
                onChange={(e) => setBlockNumber(e.target.value)}
                required
              />
            </div>
            <div className="button-container">
              <Button 
                type="submit" 
                variant="primary" 
                onClick={handleUpdate}
                disabled={loading}
              >
                {loading ? "Confirming..." : "Confirm"}
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default ConfirmPackageManually;